export default function normalizeText(text) {
	if (!text || typeof text !== 'string') return ''

	return text
		.toLowerCase()
		.replace(/ /g, '')
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, '')
		.replace(/-/g, '')
		.replace(/_/g, '')
}
